import { useEffect, useState } from "react";

export function useRailCollapsed() {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === "undefined") return false;
    const stored = window.localStorage.getItem("sidebar-pinned");
    return stored === null ? false : stored !== "true";
  });

  useEffect(() => {
    window.localStorage.setItem("sidebar-pinned", String(!collapsed));
  }, [collapsed]);

  return [collapsed, setCollapsed] as const;
}
